export class BrickGainedFocus {
   public static readonly type = '[Dashboard Actions] Brick gained focus';

   constructor(public brickInstanceId: string) {}
}

export class BrickLostFocus {
   public static readonly type = '[Dashboard Actions] Brick lost focus';

   constructor(public brickInstanceId: string) {}
}
